import { useGetData, useToggleStatusMutation } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";

const PropertyModel = () => {
  const masterHook = useMasterModule({
    queryKey: "property-models",
    idKey: "modelId",
    nameKey: "modelName",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useToggleStatusMutation,
    module: "property-models",
    statusSuccessMessage: "Property Models Status Updated Successfully",
  });

  return <MasterModuleLayout title="Property Models" hookResult={masterHook} />;
};

export default PropertyModel;
